import { NavigateFunction } from 'react-router-dom';

// Initialize with a dummy function to avoid errors
let navigate: NavigateFunction = (() => {}) as unknown as NavigateFunction;

export const initializeAuth = (navigationFunction: NavigateFunction) => {
  navigate = navigationFunction;
};

export const onAuthRequired = () => {
  if (typeof navigate === 'function') {
    navigate('/auth');
  } else {
    window.location.href = '/auth';
  }
};
